import React, { FC } from "react";

import {
  useSearchMembersSkillEvaluationTerms,
  useSkillEvaluationStandardSummaryCategorySlideNavigation,
} from "~/hooks";

import { EmployeeLayout } from "~/components/layouts";
import { SkillEvaluationTermsIndexTemplate } from "~/components/templates";

export const MembersSkillEvaluationTermsIndex: FC = () => {
  const query = new URLSearchParams(location.search);
  const businessSectionId = query.get("business_section_id") || "";

  const breadCrumbItems = [
    {
      label: "スキルマップ",
      href: `/skill_evaluation_standard_summary_categories?business_section_id=${businessSectionId}`,
    },
    {
      label: "チェック",
      href: `/skill_evaluation_terms?business_section_id=${businessSectionId}`,
    },
  ];

  const { navigations } =
    useSkillEvaluationStandardSummaryCategorySlideNavigation({
      businessSectionId,
      selectedArray: [false, true, false],
    });

  const {
    managersSkillEvaluationTerms,
    ownersSkillEvaluationTerms,
    titleKeyword,
    startDate,
    endDate,
    isManagersDataLoading,
    isOwnersDataLoading,
    onChangeDateRange,
    onChangeTitleKeyword,
    managersHasNextPage,
    managersFetchNextPage,
    ownersHasNextPage,
    ownersFetchNextPage,
    onSearchSubmit,
    onConditionReset,
  } = useSearchMembersSkillEvaluationTerms({ inTerm: true });

  return (
    <EmployeeLayout withRightSidebar breadCrumbItems={breadCrumbItems}>
      <SkillEvaluationTermsIndexTemplate
        managersSkillEvaluationTerms={managersSkillEvaluationTerms}
        ownersSkillEvaluationTerms={ownersSkillEvaluationTerms}
        titleKeyword={titleKeyword}
        startDate={startDate}
        endDate={endDate}
        isManagersDataLoading={isManagersDataLoading}
        isOwnersDataLoading={isOwnersDataLoading}
        onChangeDateRange={onChangeDateRange}
        onChangeTitleKeyword={onChangeTitleKeyword}
        managersHasNextPage={managersHasNextPage}
        managersFetchNextPage={managersFetchNextPage}
        ownersHasNextPage={ownersHasNextPage}
        ownersFetchNextPage={ownersFetchNextPage}
        onSearchSubmit={onSearchSubmit}
        onConditionReset={onConditionReset}
        navigations={navigations}
        inTerm
      />
    </EmployeeLayout>
  );
};
